<ng-container
  *transloco="let t; prefix: 'sell-with-us.reasons-to-sell-section'"
>
  <div class="mb-10">
    <h2 class="text-black rfs:text-4xl mb-6">
      {{ t("title") }}
    </h2>
    <p class="text-gray-800 mt-6 mb-10">
      {{ t("description") }}
    </p>
  </div>
  <div class="grid lg:grid-cols-2 gap-10">
    @for (item of reasonsToSellItems; track item) {
    <div class="bg-white rounded-small p-8 col-span-2 lg:col-span-1">
      <div class="mb-5">
        <img [src]="item.imgPath" alt="" class="object-fit h-[80px]" />
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="rfs:text-2xl text-black">{{ t(item.title) }}</h3>
        <p class="text-gray-700">{{ t(item.text) }}</p>
      </div>
    </div>
    }
    <ng-template [hidden]="true">
      <div class="bg-white rounded-small p-8 col-span-2">
        <div class="flex flex-col gap-10">
          <div class="flex flex-col lg:flex-row justify-between gap-3">
            <div class="order-2 lg:order-1 lg:max-w-[72%]">
              <div class="flex flex-wrap gap-4 mb-3">
                <h3 class="rfs:text-2xl text-black">
                  {{ t("card05.title") }}
                </h3>
                <span
                  class="text-primary-600 bg-primary-50 font-bold px-3 py-1 rounded-small"
                  >{{ t("card05.tag") }}</span
                >
              </div>
              <p class="text-gray-700">
                {{ t("card05.text") }}
              </p>
            </div>
            <div class="order-1 lg:order-2">
              <img src="./assets/sell-with-us/market-data.png" alt="" />
            </div>
          </div>
          <div class="max-w-[250px]">
            <button class="btn-secondary">
              <i class="icon-eye"></i><span>{{ t("card05.button") }}</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
